export function getDatesForTwoWeek(startDate: Date): Date[] {
  const dates: Date[] = [];
  for (let i = 0; i < 14; i++) {
    const date = new Date(startDate);
    date.setDate(startDate.getDate() + i);
    dates.push(date);
  }
  return dates;
}

export function getDatesForOneWeek(startDate: Date): Date[] {
  const dates: Date[] = [];
  for (let i = 0; i < 7; i++) {
    const date = new Date(startDate);
    date.setDate(startDate.getDate() + i);
    dates.push(date);
  }
  return dates;
}

export function getDateCopyDetails(currentDate: Date) {
  const currentMonth = currentDate.getMonth() + 1; // Months are 0-based in JS
  const previousMonth = currentMonth === 1 ? 12 : currentMonth - 1;
  const currentYear = currentDate.getFullYear();
  const previousYear = currentMonth === 1 ? currentYear - 1 : currentYear;

  return {
    previousMonth,
    currentMonth,
    previousYear,
    currentYear,
  };
}

export function getDatesForMonth(currentDate: Date): Date[] {
  const firstDayOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1
  );
  const lastDayOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1,
    0
  );
  const dates: Date[] = [];

  // Fill with dates of the month
  for (
    let date = firstDayOfMonth;
    date <= lastDayOfMonth;
    date.setDate(date.getDate() + 1)
  ) {
    dates.push(new Date(date)); // Add only Date objects
  }

  // Add empty slots for grid layout (if necessary) without using null
  const firstDayOfWeek = firstDayOfMonth.getDay();
  if (firstDayOfWeek > 0) {
    // Prepend empty cells as blank Date objects
    for (let i = 0; i < firstDayOfWeek; i++) {
      dates.unshift(new Date(""));
    }
  }
  return dates;
}

export function getDatesTillEndOfMonth(currentDate: Date): Date[] {
  // Create a copy of the current date to avoid mutating the original
  const startDate = new Date(currentDate);

  // Get the last day of the current month
  const lastDayOfMonth = new Date(
    startDate.getFullYear(),
    startDate.getMonth() + 1,
    0
  );
  lastDayOfMonth.setHours(23, 59, 59, 999); // Normalize to the end of the day

  // Calculate the number of days remaining in the current month
  const daysRemaining = Math.floor(
    (lastDayOfMonth.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)
  );

  // Array to store the dates
  const dates: Date[] = [];

  // If starting from the last 10 days or the last day of the month, include the next half month
  if (daysRemaining <= 10) {
    // Add dates from the current date to the end of the month
    for (
      let date = new Date(startDate);
      date <= lastDayOfMonth;
      date.setDate(date.getDate() + 1)
    ) {
      dates.push(new Date(date));
    }

    // Calculate the next half month (15 days into the next month)
    const nextMonth = new Date(
      startDate.getFullYear(),
      startDate.getMonth() + 1,
      1
    );
    const nextHalfMonthEnd = new Date(
      nextMonth.getFullYear(),
      nextMonth.getMonth(),
      15
    );

    // Add dates from the start of the next month to the next half month
    for (
      let date = new Date(nextMonth);
      date <= nextHalfMonthEnd;
      date.setDate(date.getDate() + 1)
    ) {
      dates.push(new Date(date));
    }
  } else {
    // Otherwise, just add dates from the current date to the end of the month
    for (
      let date = new Date(startDate);
      date <= lastDayOfMonth;
      date.setDate(date.getDate() + 1)
    ) {
      dates.push(new Date(date));
    }
  }

  return dates;
}

export function formatDate(date: Date | null): string {
  // Handle null or invalid dates
  if (!date || isNaN(date.getTime())) {
    return ""; // Return an empty string or a placeholder like 'N/A'
  }

  // Format valid dates
  return new Intl.DateTimeFormat("en-US", {
    weekday: "short", // e.g., "Mon"
    day: "numeric", // e.g., "1"
  }).format(date);
}

export function getAllDatesOfMonth(currentDate: Date): Date[] {
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  return Array.from(
    { length: daysInMonth },
    (_, i) => new Date(year, month, i + 1)
  );
}

export function getJapaneseDay(date: Date) {
  const days = ["Sun", "Moon", "Fire", "Water", "Wood", "Gold", "Earth"];
  const dayIndex = date.getDay();
  return days[dayIndex];
}
